import { render } from "./SectionTeacherAttendance.vue?vue&type=template&id=18ab6798"
import script from "./SectionTeacherAttendance.vue?vue&type=script&lang=js"
export * from "./SectionTeacherAttendance.vue?vue&type=script&lang=js"

import "./SectionTeacherAttendance.vue?vue&type=style&index=0&id=18ab6798&lang=scss"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__